import { BASE_FIELD_ACTIONS, type BaseFieldAction } from './base';
import { UPLOAD_FIELD_ACTIONS, type UploadFieldAction } from './upload';

export * from './base';
export * from './upload';

export const FIELD_ACTIONS = {
  ...BASE_FIELD_ACTIONS,
  ...UPLOAD_FIELD_ACTIONS,
} as const;

export type FieldAction = BaseFieldAction | UploadFieldAction;
